export default "__VITE_ASSET__TotvToaM__"